import { Module } from 'vuex';

import { RootState } from 'frontend/types';

const DEFAULT_ERROR_MESSAGE = `
  We encountered an error while talking to our servers. Refresh the page and
  try again in a few seconds. If the problem persists, please
  <a href="mailto:support@brilliant.org">email us</a>.
`;

interface ErrorModalState {
  errorModalIsVisible: boolean;
  errorMessage: string;
}

const errorModal: Module<ErrorModalState, RootState> = {
  namespaced: true,
  state: () => ({
    errorModalIsVisible: false,
    errorMessage: '',
  }),
  mutations: {
    setValue(state: ErrorModalState, value: ErrorModalState) {
      Object.assign(state, value);
    },
  },
  actions: {
    showMessage({ commit }, errorMessage = DEFAULT_ERROR_MESSAGE) {
      commit('setValue', {
        errorMessage,
        errorModalIsVisible: true,
      });
    },
    hide({ commit }) {
      commit('setValue', {
        errorModalIsVisible: false,
        errorMessage: '',
      });
    },
  },
};

export default errorModal;
